import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
} from "reactstrap";
import PendingAwardApprovals from "../components/PendingAwardApprovals";
import HistoryApprovals from "../components/HistoryApprovals";
import ManageScheduleAwardApprovals from "../components/ManageScheduleAwardApprovals";
import classnames from "classnames";
import { readAssignedPositionPermissions } from "@/services/program/budget";

const AwardApprovals = ({ organization, auth, rootProgram }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [assignedPermissions, setAssignedPermissions] = useState([]);

  const togglePan = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    let mounted = true;
    console.log('AwardApprovals - rootProgram:', rootProgram);
    console.log('AwardApprovals - enable_schedule_awards:', rootProgram?.enable_schedule_awards);
    console.log('AwardApprovals - activeTab:', activeTab);
    if (auth?.positionLevel && organization?.id && rootProgram?.id) {
      readAssignedPositionPermissions(
        organization.id,
        rootProgram.id,
        auth.positionLevel.id
      )
        .then((res) => {
          if (mounted) {
            setAssignedPermissions(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    return () => (mounted = false);
  }, [auth, organization, rootProgram]);

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === "1",
            })}
            onClick={() => {
              togglePan("1");
            }}
          >
            Pending Approvals
          </NavLink>
        </NavItem>
        {rootProgram?.enable_schedule_awards === 1 && (
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === "2",
            })}
            onClick={() => {
              togglePan("2");
            }}
          >
            Manage Approvals
          </NavLink>
        </NavItem>
        )}
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <>
            <Row>
              <Col>
                <PendingAwardApprovals
                  assignedPermissions={assignedPermissions}
                />
              </Col>
            </Row>
          </>
        </TabPane>
        {rootProgram?.enable_schedule_awards === 1 && (
        <TabPane tabId="2">
          <Row>
            <Col>
              <ManageScheduleAwardApprovals
                togglePan={togglePan}
                assignedPermissions={assignedPermissions}
              />
            </Col>
          </Row>
        </TabPane>
      )}
        
        
      </TabContent>
    </div>
  );
};

export default AwardApprovals;
